package org.hs_soft.runmynesto.pages.home.sub_page.closing_reports.components.closing_reports_content.component

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.silk.components.style.toModifier
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.HorizontalScrollBehavior
import org.hs_soft.runmynesto.domain.model.general.FooterType

import org.hs_soft.runmynesto.domain.model.general.TableColumn
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.closing_reports.CurrencyTableHeadersEnum
import org.hs_soft.runmynesto.domain.model.home.closing_reports.closing_report_detail_model.Currency
import org.hs_soft.runmynesto.domain.util.formatToTwoDecimals
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.MediumContentTitle
import org.hs_soft.runmynesto.pages.components.CustomTable


@Composable
fun Currency(
    data: List<Currency>?,
    windowSizeMode: WindowSizeModeEnum,
    companyProfileId: String?,
) {
    MediumContentTitle(
        marginTop = Dimen.mediumPadding,
        title = Strings.current().currency
    )


    Column(
        modifier = HorizontalScrollBehavior.toModifier()
            .fillMaxWidth()
            .margin(topBottom = Dimen.mediumPadding)
    ) {
        val columns = CurrencyTableHeadersEnum.entries.map { headerEnum ->
            TableColumn(
                header = headerEnum.getTitle(companyProfileId),
                key = headerEnum.key,
                isNumeric = headerEnum.isNumeric,
            )
        }

        val tableData = data?.map { model ->
            mapOf(
                CurrencyTableHeadersEnum.CURRENCY.key to (model.name ?: ""),
                CurrencyTableHeadersEnum.LST.key to (if (model.present == 0.0) ""
                    else model.present?.toString() ?: ""),
                CurrencyTableHeadersEnum.COURSE.key to formatToTwoDecimals(model.exchangeRate),
                CurrencyTableHeadersEnum.CURRENCY_TYPE.key to formatToTwoDecimals(model.presentConverted),
                CurrencyTableHeadersEnum.CASH_DELIVERY.key to formatToTwoDecimals(model.cashInTransit),
                CurrencyTableHeadersEnum.DIFFERENCE.key to formatToTwoDecimals(model.difference),
                CurrencyTableHeadersEnum.AMOUNT.key to formatToTwoDecimals(model.amount),
                CurrencyTableHeadersEnum.AMOUNT_CHF.key to formatToTwoDecimals(model.amountConverted)
            )
        }

        CustomTable(
            columns = columns,
            data = tableData,
            footerType = FooterType.NONE
        )
    }

}